import React from 'react';
import { SectionStatus } from '../../sections/types';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { CustomHeading, TimeIndicator, Title } from 'shared-components';
import { useTranslation } from "react-i18next";

interface IProps {
  children: React.ReactNode;
  section1?: SectionStatus;
  section2?: SectionStatus;
  section3?: SectionStatus;
  section4?: SectionStatus;
  section?: string;
  minsToComplete?: number;
  hideProgress?: boolean;
  proceedLabel?: string;
  onNext?: () => void;
  onPrevious?: () => void;
  onBackToTaskList?: () => void;
}

const SectionStartPage: React.FC<IProps> = props => {
    const { t } = useTranslation('common');
  const { children, section, minsToComplete, proceedLabel, onNext, onPrevious, onBackToTaskList } = props;

  return (
    <>
      <Title title={section} />

      {onBackToTaskList && (
        <Button
          onClick={onBackToTaskList}
          leftIcon={<FontAwesomeIcon icon={faArrowLeft} className="utility-icon" />}
          variant={'ghost'}
          ml={-3}
        >
          {t('common:backToTaskList')}
                          </Button>
      )}

      <Box pt={4}>
        <CustomHeading level="h1" mb={6}>
          {section}
        </CustomHeading>

        <Box>
          {children}

          {minsToComplete ? (
            <Flex alignItems="center" my={8} gap={6} maxWidth="24rem" mx="auto">
              <TimeIndicator value={minsToComplete * 1.6} label={t('common:min', { minsToComplete })} />

              <Text mb={0} color="muted">
                {t('common:thisSectionWillTakeAround')}{' '}
                <b>
                  {minsToComplete} {t('common:minute')}{minsToComplete > 1 && 's'}
                </b>{' '}
                {t('common:toComplete')}
                                            </Text>
            </Flex>
          ) : null}

          <Flex justifyContent={'end'} mt={8}>
            <Button onClick={onPrevious} size={'lg'} mr={'auto'}>
              {t('common:previousPage')}
                                      </Button>

            <Button id="save_and_complete" onClick={onNext} variant={'solid'} size={'lg'}>
              {proceedLabel || 'Start Section'}
            </Button>
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default SectionStartPage;
